import LC from "@kugou/light-mobilecall";
import {getQueryString} from './Utils/Utils/index'
//获取渠道
function getChannel() {
  if ((/MicroMessenger/gi).test(window.navigator.userAgent)) {
    return '微信'
  } else if ((/qq/gi).test(window.navigator.userAgent)) {
    return 'QQ'
  } else if ((/weibo/gi).test(window.navigator.userAgent)) {
    return '微博'
  } else if (LC.isInClient()) {
    return '酷狗客户端'
  } else {
    return '其他'
  }
}
var hreffrom = getQueryString("hreffrom") || getQueryString("from") || getQueryString("source")
var channel = getChannel();

//bi上报
window.apmCollectData = window.apmCollectData || [];
window.pushBI = function (config, exposure) {
  config.channel = config.channel || window.saveChannel || channel;
  var basicData = Object.assign({
    appid: LC.isIOS ? 1000 : LC.isAndroid ? 1005 : 1058,
    timestamp: Date.parse(new Date()),
    userid: window.$userInfo && window.$userInfo.userid || "",
    mid: window.$userInfo && window.$userInfo.mid || "",
    uuid: window.$userInfo && window.$userInfo.uuid || "",
    hreffrom: hreffrom
  }, config);
  
  if (exposure) {
    basicData.b = "曝光";
  } else {
    //默认是点击
    basicData.b = "点击";
  }
  window.apmCollectData.push([30050, basicData, null, false]);;
  try {
    window.newLogCount();
  } catch (ex) { }
}